// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1KXE2","approved":"Status_approved__1UUE-","rejected":"Status_rejected__2S0WM","expired":"Status_expired__2CQsd","label":"Status_label__3gGlQ"};